import { CompFileUploadCore } from '../core/forms/file-upload/comp'

export const CompFileUpload = CompFileUploadCore
